// removed by extract-text-webpack-plugin
module.exports = {"main":"containers-App-app__main__1f5bG"};


//////////////////
// WEBPACK FOOTER
// ./containers/App/app.scss
// module id = 378
// module chunks = 0